import ErrService from '@/services/ErrService'

import { useSessionStore } from '@/stores/session'

class ApiBase {
  constructor(transport) {
    if (!transport) {
      throw new Error('Api transport cannot be undefined')
    }
    this.transport = transport
  }

  _getUserId(userId) {
    const sessionStore = useSessionStore()
    return (
      userId ||
      (sessionStore.isUserLoggedIn && sessionStore.user?.uid ? sessionStore.user.uid : 'anonymous')
    )
  }

  _decorateNetworkError(error, options = {}) {
    options = { errorLevel: 'network', ...options }
    return ErrService.decorateError(this.constructor.name, error, options)
  }

  _withDecoratedPromise(cb, options) {
    return new Promise((resolve, reject) => {
      cb()
        .then((response) => {
          resolve(response)
        })
        .catch((reason) => {
          reject(this._decorateNetworkError(reason, options))
        })
    })
  }
}

export default ApiBase
